export const fieldsExcludedFromStorage = [
  "cvc",
  "vencimiento",
  "titular",
  "numeroTarjeta",
  "formaDePago",
  "cbu",
  "perrito chancho",
  "dniTitular",
  "bancoEmisor",
];
